import { useState } from "react";
import { NavbarContainer } from "../../../layout/navbar/Navbar.style";
import Notification from "../../../modals/Notification";
import NavRight2 from "../../../layout/navbar/NavRight2";

const AdminNavbar = ({ header }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  
  // Ensure that Navbar2 receives header prop
  return (
    <NavbarContainer>
      {/* <Searchbar /> */}
      <h3>{header}</h3> {/* Display the header prop */}
      <NavRight2 is_admin setIsOpenModal={setIsOpenModal} />
      <Notification isOpenModal={isOpenModal} setIsOpenModal={setIsOpenModal} />
    </NavbarContainer>
  );
};

export default AdminNavbar;
